import axios from '../util/axiosConfig';

export const fetchNewToken = async () => {
  const refreshToken = localStorage.getItem('refreshToken');

  if (!refreshToken) return null;
  try {
    const response =  await axios.post('/auth/refreshtoken', { token: refreshToken });

    const { accessToken } = response.data;
    if (!accessToken) throw new Error('No access token in response');

    return accessToken;
  } catch (error) {
    console.error('Token refresh failed', error);
    throw error;
  }
  // try {
  //   const response = await axios.post('/auth/refreshtoken', { token: refreshToken });
  //   return response.data.data;
  // } catch (error) {
  //   localStorage.clear();
  //   sessionStorage.clear();
  //   return null;
  // }
};

export const refreshAuth = async (failedRequest: any) => {
  const response = await fetchNewToken();

  if (!response) return Promise.reject();

  const { accessToken, refreshToken } = response;

  if (accessToken) {
    failedRequest.response.config.headers.Authorization = `Bearer ${accessToken}`;
    localStorage.setItem('token', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    return Promise.resolve(accessToken);
  } else {
    return Promise.reject();
  }
};
